<template lang='pug'>
v-container
  WaterToolbar(
    :date='date'
    @update:date='date => $router.push({ params: { date } })'
  )
  Reload(
    :key='date'
    v-slot='{ reload }'
  )
    WaterCard(
      :date='date'
      :preferencesUnit='$store?.state?.preferencesUnitModule?.preferencesUnit'
      @update:milliliters='reload'
      @update:preferencesUnit='preferencesUnit => $store.commit("preferencesUnitSet", preferencesUnit)'
    )
</template>

<script>
import Reload from '@thomasphan/vue-components/src/components/Reload.vue';
import WaterCard from '@thomasphan/vue-components/src/components/WaterCard.vue';
import WaterToolbar from '@thomasphan/vue-components/src/components/WaterToolbar.vue';

export default
{
  components:
  {
    Reload,
    WaterCard,
    WaterToolbar,
  },
  props:
  {
    date: { required: true }
  }
};
</script>